module.exports = __webpack_public_path__ + "static/media/count25Off_118.9e52a0b9.png";